export const NAME_VALIDATION_REGEX = /^[Ѐ-ӿ\-'(). "/]*$/;
export const NAME_CYR_OR_LAT_VALIDATION_REGEX = /^[A-Za-zЀ-ӿ\-'(). "/]*$/;
export const POST_CODE_VALIDATION_REGEX = /(([a-zA-Z0-9\-' ."/]*))$/;

export const YEAR_VALIDATION_REGEX = /^([12]\d{3})*$/;
export const NUMBER_VALIDATION_REGEX = /^\d*$/g;
export const DECIMAL_NUMBER_VALIDATION_REGEX = /^\d*\.?\d{0,2}$/g;

export const DOSSIER_NUMBER_REGEX = /^[\w-]+\/\d{2}\.\d{2}\.\d{4}$/g;
